import storage from 'viralstyle-ui/src/storage';
import find from 'lodash/find';
import remove from 'lodash/remove';

import { RecentlyViewedModel } from './models';

const RECENT_KEY = 'recent-campaigns';

export const state = {
  featuredCampaigns: [],
  recentCampaigns: storage.get(RECENT_KEY) || [],
  hobbiesCampaigns: [],
  occupationsCampaigns: [],
};

export const mutations = {
  addRecentlyViewedCampaign(state, campaign) {
    let recentlyViewedCampaign = new RecentlyViewedModel(campaign),
      alreadyViewedCampaign = find(state.recentCampaigns, campaign => campaign.uri === recentlyViewedCampaign.uri);

    if (alreadyViewedCampaign) {
      remove(state.recentCampaigns, alreadyViewedCampaign);

      state.recentCampaigns.unshift(recentlyViewedCampaign);
    } else {
      state.recentCampaigns.unshift(recentlyViewedCampaign);

      state.recentCampaigns.slice(0, 4);
    }

    storage.set(RECENT_KEY, state.recentCampaigns);
  },

  removeRecentlyViewedCampaign(state, campaign) {
    let recentlyViewedCampaign = new RecentlyViewedModel(campaign);

    if (find(state.recentCampaigns, campaign => campaign.uri === recentlyViewedCampaign.uri)) {
      remove(state.recentCampaigns, campaign => campaign.uri === recentlyViewedCampaign.uri);

      storage.set(RECENT_KEY, state.recentCampaigns);
    }
  },

  removeRecentlyViewedCampaignError(state, { publicName, slug }) {
    if (find(state.recentCampaigns, campaign => campaign.uri === `/${publicName}/${slug}`)) {
      remove(state.recentCampaigns, campaign => campaign.uri === `/${publicName}/${slug}`);

      storage.set(RECENT_KEY, state.recentCampaigns);
    }
  },
};